import React, { useReducer } from 'react';

import { firestoreInitialize } from 'config/firebase/client';

import CitiesContext from './CitiesContext';
import CitiesReducer from './CitiesReducer';

const CitiesState = (props) => {
    const initialState = {
        getCities: {
            cities: [],
            firstCity: null,
            lastCity: null,
            nextCities: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getCitiesById: {
            city: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCityPetPoint: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCurrency: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updatePaymentMethod: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    }

    const [state, dispatch] = useReducer(CitiesReducer, initialState);

    const getCities = () => {
        dispatch({ type: 'GET_CITIES_LOADING' });

        let db = firestoreInitialize();

        db.collection("Ciudades").get().then((documentSnapshots) => {
            dispatch({ type: 'GET_CITIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } });
        })
        .catch((error) => dispatch({ type: 'GET_CITIES_ERROR', payload: { code: 'cities/error', message: error } }));
    }

    const getCitiesById = (id) => {
        dispatch({ type: 'GET_CITIES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collection("Ciudades").doc(id).get().then((querySnapshot) => {
            dispatch({ type: 'GET_CITIES_BY_ID', payload: querySnapshot.data() });
        })
        .catch((error) => dispatch({ type: 'GET_CITIES_BY_ID_ERROR', payload: { code: 'city/error', message: error } }));
    }

    const updateCityPetPoint = (id, petPointValue) => {
        dispatch({ type: 'UPDATE_CITY_PET_POINT_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Ciudades").doc(id);

        docRef.update({
            valorPunto: petPointValue,
        })
        .then(() => {
            dispatch({ type: 'UPDATE_CITY_PET_POINT' });
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_CITY_PET_POINT_ERROR', payload: { code: 'city-pet-point/update-error', message: error } });
        });
    };

    const resetUpdateCityPetPointState = () => {
        dispatch({ type: "UPDATE_CITY_PET_POINT_RESET_STATE" });
    };

    const updateCurrency = (id, city, currency) => {
        dispatch({ type: 'UPDATE_CURRENCY_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Ciudades").doc(id);

        docRef.update({
            [`monedas.${city}`]: {
                esPrincipal: currency.esPrincipal,
                metodosDePago: currency.metodosDePago,
                simbolo: currency.simbolo,
                status: currency.status,
                tasa: currency.tasa,
            },
        })
        .then(() => {
            dispatch({ type: 'UPDATE_CURRENCY' });
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_CURRENCY_ERROR', payload: { code: 'currency/update-error', message: error } });
        });
    };

    const resetUpdateCurrencyState = () => {
        dispatch({ type: "UPDATE_CURRENCY_RESET_STATE" });
    };

    const updatePaymentMethod = (id, currency, paymentMethod, isActive) => {
        dispatch({ type: 'UPDATE_PAYMENT_METHOD_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Ciudades").doc(id);

        docRef.update({
            [`monedas.${currency}.metodosDePago.${paymentMethod}`]: isActive,
        })
        .then(() => {
            dispatch({ type: 'UPDATE_PAYMENT_METHOD' });
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_PAYMENT_METHOD_ERROR', payload: { code: 'payment-method/update-error', message: error } });
        });
    };

    const resetUpdatePaymentMethodState = () => {
        dispatch({ type: "UPDATE_PAYMENT_METHOD_RESET_STATE" });
    };

    return (
        <CitiesContext.Provider value={{
            citiesState: state.getCities,
            citiesByIdState: state.getCitiesById,
            updateCityPetPointState: state.updateCityPetPoint,
            updateCurrencyState: state.updateCurrency,
            updatePaymentMethodState: state.updatePaymentMethod,
            getCities,
            getCitiesById,
            updateCurrency,
            resetUpdateCurrencyState,
            updatePaymentMethod,
            resetUpdatePaymentMethodState,
            updateCityPetPoint,
            resetUpdateCityPetPointState
        }}>
            {props.children}
        </CitiesContext.Provider>
    )
}

export default CitiesState;
